import React from 'react';
import Slider from 'react-slick';
function Testimonials() {
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        cssEase: "linear",
        responsive: [
            { breakpoint: 1024, settings: { slidesToShow: 2, slidesToScroll: 1 } },
            { breakpoint: 767, settings: { slidesToShow: 1, slidesToScroll: 1 } }, // ✅ Fixed breakpoint
            { breakpoint: 600, settings: { slidesToShow: 1, slidesToScroll: 1 } },
            { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } }
        ]
    };
    return (
        <Slider {...settings}>
            <div className='TestimonialsBox'>
                <img
                    src="https://webapi.entab.info/api/image/SMNSB/public/images/Testimonials-Bg.png"
                    className="testimonial-image"
                    alt="smnsbokaro" />
                <div className="testimonial-overlay">
                    <p>“Walking my son into the same classrooms where I once studied fills me with pride. St. Mary’s Nursery School isn’t just a school for us—it’s family. The teachers are warm, patient, and truly understand every child’s emotional and learning needs. The NEP-based approach and smart classrooms make learning so joyful. I couldn’t think of a better place to begin my child’s journey.”</p>
                </div>
                <h5>Mrs. Neha Sharma </h5>
                <h6>Parent & Former Student</h6>
            </div>
            <div className='TestimonialsBox'>
                <img
                    src="https://webapi.entab.info/api/image/SMNSB/public/images/Testimonials-Bg.png"
                    className="testimonial-image"
                    alt="smnsbokaro" />
                <div className="testimonial-overlay">
                    <p>“We are the third generation in our family to trust St. Mary’s! My mother studied here, I studied here, and now my daughter is continuing the legacy. The school beautifully blends modern education with strong moral values. Bagless Fridays and activity-based learning have made my child love school every single day!”</p>
                </div>
                <h5>Mr. Rohit & Mrs. Anjali Mehta </h5>
            </div>
            <div className='TestimonialsBox'>
                <img
                    src="https://webapi.entab.info/api/image/SMNSB/public/images/Testimonials-Bg.png"
                    className="testimonial-image"
                    alt="smnsbokaro" />
                <div className="testimonial-overlay">
                    <p>“My grandchildren are now learning under the same care and values that my children once received here decades ago. SMNS continues to uphold its reputation for safety, compassion, and quality education. The teachers’ dedication and the principal’s personal attention to every child are truly commendable.”</p>
                </div>
                <h5>Mrs. Reshma Roy</h5>
                <h6>Grandparent</h6>
            </div>
            <div className='TestimonialsBox'>
                <img
                    src="https://webapi.entab.info/api/image/SMNSB/public/images/Testimonials-Bg.png"
                    className="testimonial-image"
                    alt="smnsbokaro" />
                <div className="testimonial-overlay">
                    <p>“We were amazed to see how smoothly our little one settled in. The school ensures emotional comfort and fun-filled learning from day one. From the RO water plant to clean surroundings and constant power backup—every detail reflects how much the school cares. We’re so grateful for the loving start our son has got.”</p>
                </div>
                <h5>Mr. Md. Ansari & Mrs. Shabnam Ansari</h5>
            </div>
        </Slider>
    );
}

export default Testimonials;
